import { z } from 'zod';

export const OrganizationListRSModel = z
  .object({
    flattenExternalSystemCode: z.string(),
    code: z.string(),
    name: z.string(),
    startYear: z.number().nullable(),
    endYear: z.number().nullable(),
  })
  .array();

export const OrganizationListModel = z
  .object({
    flattenExternalSystemCode: z.string(),
    code: z.string(),
    externalSystemCode: z.string(),
    name: z.string(),
    startYear: z.number().nullable(),
    endYear: z.number().nullable(),
  })
  .array();
